import React from 'react';
import { useDroppable } from '@dnd-kit/core';

export function GridSquare(props) {
  const { isOver, setNodeRef } = useDroppable({
    id: props.id
  });
  const style = {
    overflow: 'visible',
    borderStyle: 'solid',
    borderColor: 'green',
    borderWidth: isOver ? 2 : 0,
  };
  return (
    <div ref={setNodeRef} style={style}>
      {props.children}
    </div>
  );
}
